<template>
    <div>
        <BaseIcon 
            ref="trigger" 
            :title="title || $t('More Information')"
            :icon="computedIcon"
            :clickable="clickable"
            :inline-position="inlinePosition"
            :disabled="disabled"
            class-name="js-flyout-trigger"
            @click.stop="toggleFlyout()"
        />

        <Portal v-if="isActive"
            to="flyout-content"
            slim
        >
            <slot v-bind="{
                hideFlyout 
            }"
            >
                <div v-html="$cleanDom(bodyHTML)"></div>
            </slot>
        </Portal>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { useFlyout } from '@/vue/store/useFlyout';
const {isActive, toggleFlyout, hideFlyout} = useFlyout();

interface IBaseFlyoutData {
    MAX_HEIGHT: number;
    initialPositionLeft: number;
    initialPositionTop: number;
}

export default Vue.extend({
    props: {
        id: {
            type: String,
        },
        title: {
            type: String
        },
        bodyHTML: {
            type: String, //HTML that goes inside the Flyout
            default:''
        },
        clickable: {
            type: Boolean,
            default: true
        },
        // TODO: this should be refactored to a single property
        disabled: Boolean,
        useCaret: Boolean,
        useComment: Boolean,
        inlinePosition: {
            type: String,
            default: ''
        },
    },
    data(): IBaseFlyoutData {
        return {
            MAX_HEIGHT: 160,
            initialPositionLeft: -1,
            initialPositionTop: -1,
        };
    },
    computed: {
        isActive(): boolean {
            return isActive(this.computedID);
        },
        computedID(): string {
            return this.id ? `${this.id}_${this._uid}` : this._uid;
        },
        computedIcon(): string {
            if (this.useCaret) {
                return this.isActive ? 'collapse-left' : 'collapse-right';
            }

            if (this.useComment) {
                return 'comment';
            }
                
            return 'help';
        }
    },
    methods: {
        hideFlyout,
        clearActiveFlyout(): void {
            if (this.initialPositionTop === this.getPositionTop() &&
                this.initialPositionLeft === this.getPositionLeft()) {
                return;
            }
        },
        toggleFlyout(): void {
            toggleFlyout(this.computedID, this.$refs.trigger.$refs.icon, (this.title || this.$t('More Information')));
        }
    }
});
</script>
